import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { FiMail, FiMapPin, FiArrowRight } from 'react-icons/fi';
import './ContactSection.css';

const ContactSection = () => {
  const { t } = useTranslation();

  const contactInfo = [
    {
      icon: FiMapPin,
      title: t('contact.address'),
      content: 'Markstraße 37, 13409 Berlin'
    },
    {
      icon: FiMail,
      title: t('contact.email'),
      content: 'info@dldmn-baumanagement.de'
    }
  ];

  return (
    <section id="contact" className="contact-section section-padding">
      <div className="container">
        <div className="contact-content">
          <motion.div
            className="contact-info"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="section-title">{t('contact.title')}</h2>
            <p className="section-subtitle">{t('contact.subtitle')}</p>

            <div className="contact-details">
              {contactInfo.map((info, index) => (
                <motion.div
                  key={index}
                  className="contact-item"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  viewport={{ once: true }}
                >
                  <div className="contact-icon">
                    <info.icon />
                  </div>
                  <div className="contact-text">
                    <h4>{info.title}</h4>
                    <p>{info.content}</p>
                  </div>
                </motion.div>
              ))}
            </div>

            <motion.div
              className="contact-cta"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <Link to="/contact" className="btn btn-primary">
                {t('contact.getInTouch')}
                <FiArrowRight />
              </Link>
            </motion.div>
          </motion.div>

          <motion.div
            className="contact-visual"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <div className="contact-card">
              <div className="card-header">
                <h3>{t('contact.projectCard.title')}</h3>
                <p>{t('contact.projectCard.subtitle')}</p>
              </div>

              <div className="card-features">
                <div className="feature-item">
                  <div className="feature-number">01</div>
                  <div className="feature-text">
                    <h4>{t('contact.projectCard.consultation.title')}</h4>
                    <p>{t('contact.projectCard.consultation.description')}</p>
                  </div>
                </div>

                <div className="feature-item">
                  <div className="feature-number">02</div>
                  <div className="feature-text">
                    <h4>{t('contact.projectCard.planning.title')}</h4>
                    <p>{t('contact.projectCard.planning.description')}</p>
                  </div>
                </div>

                <div className="feature-item">
                  <div className="feature-number">03</div>
                  <div className="feature-text">
                    <h4>{t('contact.projectCard.execution.title')}</h4>
                    <p>{t('contact.projectCard.execution.description')}</p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;

